"use strict";

module.exports = {
  'name': 'null',
  'category': 'Constants',
  'syntax': ['null'],
  'description': 'Value null',
  'examples': ['null'],
  'seealso': ['true', 'false']
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/constants/null.js
// module id = 795
// module chunks = 0